export default "/bundles/assets/scroll-right_6b8b3af8e26d4d0accff802fe788f3f0.png";